import React, {FC} from 'react';
import DynamicAsset from 'components/DynamicAsset';
import {motion} from 'framer-motion';
import {useIsMobile} from 'hooks/useIsMobile';

import * as styles from './styles.module.scss';

type InfoPanelRowItemProps = {
	imageSrc: string
	title: string
	description: string
	subdesc?: string
}

// Set of animation props designed to run
// repeatedly => mobile view
const mobileProps = {
	variants: {
		hidden: {
			opacity: 0,
		},
		show: {
			opacity: 1,
		},
	},
};

// Set of animation props designed to run
// only once => desktop view
const desktopProps = {
	viewport: {once: true},

	variants: {
		hidden: {
			opacity: 0,
			x: '20%',
			'--text-blur': '5px',
		},
		show: {
			opacity: 1,
			x: 0,
			'--text-blur': '0px',
		},
	},

};

const InfoPanelRowItem: FC<InfoPanelRowItemProps> = ({
	imageSrc,
	title,
	description,
	subdesc,
}) => {
	const mobile = useIsMobile();
	const motionProps = {
		className: styles.item,

		initial: 'hidden',
		whileInView: 'show',

		transition: {
			duration: 0.5,
		},

		...(mobile ? mobileProps : desktopProps),
	};

	return (
		<motion.div {...motionProps}>
			<DynamicAsset imageSrc={imageSrc} alt={title} />
			<div className={styles.title}>{title}</div>
			<div className={styles.description}>{description}</div>
			{subdesc && <div className={styles.subdesc}>{subdesc}</div>}
		</motion.div>
	);
};
export default InfoPanelRowItem;
